import * as ambassadorWixReceiptsV1ReceiptsSettings from './receipts-v1-receipts-settings-receipts-settings.http.js';
import * as ambassadorWixReceiptsV1ReceiptsSettingsTypes from './receipts-v1-receipts-settings-receipts-settings.types.js';
import * as ambassadorWixReceiptsV1ReceiptsSettingsUniversalTypes from './receipts-v1-receipts-settings-receipts-settings.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getReceiptsSettings(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixReceiptsV1ReceiptsSettingsUniversalTypes.GetReceiptsSettingsRequest,
  ambassadorWixReceiptsV1ReceiptsSettingsTypes.GetReceiptsSettingsRequest,
  ambassadorWixReceiptsV1ReceiptsSettingsUniversalTypes.GetReceiptsSettingsResponse,
  ambassadorWixReceiptsV1ReceiptsSettingsTypes.GetReceiptsSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixReceiptsV1ReceiptsSettings.getReceiptsSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/receipts-settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateReceiptsSettings(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixReceiptsV1ReceiptsSettingsUniversalTypes.UpdateReceiptsSettingsRequest,
  ambassadorWixReceiptsV1ReceiptsSettingsTypes.UpdateReceiptsSettingsRequest,
  ambassadorWixReceiptsV1ReceiptsSettingsUniversalTypes.UpdateReceiptsSettingsResponse,
  ambassadorWixReceiptsV1ReceiptsSettingsTypes.UpdateReceiptsSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixReceiptsV1ReceiptsSettings.updateReceiptsSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/receipts-settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  ReceiptsSettings as ReceiptsSettingsOriginal,
  Numbering as NumberingOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  GetReceiptsSettingsRequest as GetReceiptsSettingsRequestOriginal,
  GetReceiptsSettingsResponse as GetReceiptsSettingsResponseOriginal,
  UpdateReceiptsSettingsRequest as UpdateReceiptsSettingsRequestOriginal,
  UpdateReceiptsSettingsResponse as UpdateReceiptsSettingsResponseOriginal,
  NextNumberDescendingErrorDetails as NextNumberDescendingErrorDetailsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  GetReceiptsSettingsApplicationErrors as GetReceiptsSettingsApplicationErrorsOriginal,
  UpdateReceiptsSettingsApplicationErrors as UpdateReceiptsSettingsApplicationErrorsOriginal,
} from './receipts-v1-receipts-settings-receipts-settings.types.js';
